export const SEARCH_VENDORS = 'SEARCH_VENDORS'
export const SEARCH_VENDORS_FAILED = 'SEARCH_VENDORS_FAILED'
export const SEARCH_VENDORS_SUCCEEDED = 'SEARCH_VENDORS_SUCCEEDED'

export const CREATE_VENDOR = 'CREATE_VENDOR'
export const CLEAR_CREATED_VENDOR = 'CLEAR_CREATED_VENDOR'
export const CREATE_VENDOR_FAILED = 'CREATE_VENDOR_FAILED'
export const CREATE_VENDOR_SUCCEEDED = 'CREATE_VENDOR_SUCCEEDED'
